// extracted by mini-css-extract-plugin
module.exports = {"outerwrapper":"ImageWrapperAlt_outerwrapper__VEq9P","wrapper":"ImageWrapperAlt_wrapper__oY_jH"};